(() => {

  function convertPrice(el) {
    const rawText = el.textContent.trim();
    const numeric = parseFloat(rawText.replace(/[^\d.]/g, ''));
    if (isNaN(numeric)) return;

    const rate = parseFloat(window.Shopify.currency.rate);
    const active = window.Shopify.currency.active;
    const format = window.hulkapps.money_format;

    const converted = (numeric * rate).toFixed(2);
    el.textContent = `${format.replace('{{amount}}', converted)} ${active}`;
    el.dataset.hulkConvertCurrency = 'false';
  }

  function runConversion() {
    const elements = document.querySelectorAll('[data-hulk-convert-currency="true"]');
    console.log("Eee", elements)
    if (!elements.length) return;
    elements.forEach(convertPrice);
  }

  function initCurrencyObserver() {
    const observer = new MutationObserver(() => runConversion());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    runConversion();
    initCurrencyObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
